// extracted by mini-css-extract-plugin
export default {"upgradeContainer":"CRMGnT","storeImage":"BYiBmq","subtitle":"U2Nr0W"};